import UpgradeLink from "./UpgradeLink";

export default UpgradeLink;



// WEBPACK FOOTER //
// ./src/shared/components/NavBar/UpgradeLink/index.js